import { SellerFilterOption } from '@/components/SellerFilter/SellerFilterUi';
import dayjs from 'dayjs';
import { FilterUi, KamOptionUi, StatusOptionUi } from './FilterUi';

export const ORDER_ID_KEY = 'orderId';
export const KAMS_PARAM_KEY = 'kams';
export const REMISSION_STATUS_PARAM_KEY = 'remission';
export const ORDER_SELLER_PARAM_KEY = 'seller';
export const STATUS_PARAM_KEY = 'status';
export const DATE_PARAM_KEY = 'date';

export function FilterUiToFilterParams(input: FilterUi): URLSearchParams {
  const params: URLSearchParams = new URLSearchParams();
  if (input.orderId) {
    params.set(ORDER_ID_KEY, input.orderId);
  }

  if (input.startDate && input.endDate) {
    params.set(
      DATE_PARAM_KEY,
      `${dayjs(input.startDate).format('YYYY-MM-DD')}_${dayjs(input.endDate).format('YYYY-MM-DD')}`
    );
  }

  if (input.sellers.length) {
    params.set(ORDER_SELLER_PARAM_KEY, JSON.stringify(input.sellers));
  }

  const statusOptionSelected = input.statusOptions.find(
    (value) => value.statusId === input.selectedStatusId
  );
  if (statusOptionSelected) {
    params.set(STATUS_PARAM_KEY, JSON.stringify(statusOptionSelected));
  }

  if (input.remissionStatusId) {
    params.set(REMISSION_STATUS_PARAM_KEY, input.remissionStatusId);
  }

  if (input.selectedKamIds.length) {
    const selectedKams = input.kamFilterOptions.filter((option) =>
      input.selectedKamIds.includes(option.id)
    );
    params.set(KAMS_PARAM_KEY, JSON.stringify(selectedKams));
  }
  return params;
}

export function FilterParamsToFilterUi(
  searchParams: URLSearchParams
): FilterUi {
  const dateParam = searchParams.get(DATE_PARAM_KEY)?.split('_') ?? null;
  let startDate: Date | undefined;
  let endDate: Date | undefined;
  if (dateParam?.length === 2) {
    startDate = dayjs(dateParam[0], 'YYYY-MM-DD').toDate();
    endDate = dayjs(dateParam[1], 'YYYY-MM-DD').toDate();
  }

  const sellersFilterJson = searchParams.get(ORDER_SELLER_PARAM_KEY);
  let sellersFilter: SellerFilterOption[] = [];
  if (sellersFilterJson) {
    sellersFilter = JSON.parse(sellersFilterJson) as SellerFilterOption[];
  }

  const selectedStatusJson = searchParams.get(STATUS_PARAM_KEY);
  let selectedStatus: StatusOptionUi | undefined;
  if (selectedStatusJson) {
    selectedStatus = JSON.parse(selectedStatusJson) as StatusOptionUi;
  }

  const remissionStatusId = searchParams.get(REMISSION_STATUS_PARAM_KEY);

  const selectedKamsJson = searchParams.get(KAMS_PARAM_KEY);
  let selectedKams: KamOptionUi[] = [];
  if (selectedKamsJson) {
    selectedKams = JSON.parse(selectedKamsJson) as KamOptionUi[];
  }

  const ret: FilterUi = {
    orderId: searchParams.get(ORDER_ID_KEY) ?? '',
    startDate,
    endDate,
    sellers: sellersFilter,
    selectedSellersInitiallySelected: sellersFilter,
    kamFilterOptions: selectedKams,
    selectedKamIds: selectedKams.map((kamOption) => kamOption.id),
    statusOptions: selectedStatus ? [selectedStatus] : [],
    selectedStatusId: selectedStatus?.statusId ?? '',
    remisionStatusOptions: [
      {
        statusId: 'true',
        statusName: 'Recibida',
      },
      {
        statusId: 'false',
        statusName: 'Pendiente',
      },
    ],
    remissionStatusId: remissionStatusId ?? '',
  };
  return ret;
}
